import { useEffect, useState } from "react";
import { api } from "../lib/api";

type AuthState = "loading" | "authed" | "anon";
export interface Me { email: string; is_admin: boolean; }

export function useAuth() {
  const [state, setState] = useState<AuthState>("loading");
  const [me, setMe] = useState<Me | null>(null);

  useEffect(() => {
    let alive = true;
    api.me()
      .then((m) => { if (alive) { setState("authed"); setMe({ email: m.email, is_admin: m.is_admin }); } })
      .catch(() => { if (alive) setState("anon"); });
    return () => { alive = false; };
  }, []);

  return {
    state,
    me,
    setAuthed: (next: Me) => { setState("authed"); setMe(next); },
    logout: async () => { await api.logout(); setState("anon"); setMe(null); },
  };
}
